import Vue from 'vue';

export default class ListUtils {
  static loadItemsData (instance, config) {
    instance.loaded = false;
    instance.loadError = false;

    const responseHandler = (response) => {
      instance[config.listField] = response.data.data;
      instance.loaded = true;

      if (config.pagination) {
        instance.paginationMetaData = response.data.meta || null;
      }

      if (config.successAction) {
        config.successAction(response.data);
      }
    }

    const errorHandler = (error) => {
      console.log(error);
      instance.loadError = true;
    }

    if (config.method === 'GET') {
      instance.$http.get(config.endpoint, config.params).then(responseHandler).catch(errorHandler);
    } else {
      instance.$http.post(config.endpoint, config.params).then(responseHandler).catch(errorHandler);
    }
  }

  static AcceptReservationList (instance, config) {
    Vue.swal({
      title: 'Czy na pewno chcesz zmienić status?',
      text: 'Podaj przybliżoną liczbę miesięcy oczekiwania na wizytę. Wartość ta zostanie przekazana do rodzica w powiadomieniu o zatwierdzeniu zgłoszenia.',
      input: 'number',
      type: 'question',
      showCancelButton: true,
      confirmButtonText: 'Zaakceptuj',
      cancelButtonText: 'Anuluj',
      inputValidator: (value) => {
        if (!value) {
          return 'To pole jest wymagane!';
        }
        return null;
      }
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpointBase + config.id, {
          months: result.value
        }).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: 'Zaakceptowano',
              html: 'Rezerwacja została zaakceptowana',
              type: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            Vue.swal({
              title: 'Wystąpił błąd!',
              html: 'Zmiana statusu nie powiodła się',
              type: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.cancelAction();
            });
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: 'Wystąpił błąd!',
            html: 'Zmiana statusu nie powiodła się',
            type: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }

  static SendReservationListInfo (instance, config) {
    Vue.swal({
      title: 'Czy na pewno chcesz wysłać przypomnienia',
      showCancelButton: true,
      confirmButtonText: 'Tak',
      cancelButtonText: 'Nie',
      showLoaderOnConfirm: true,
      closeOnConfirm: false,
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpointBase, {
        }).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: 'Wysłano',
              html: 'Wiadomości zostały wysłane do odbiorców',
              type: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            Vue.swal({
              title: 'Wystąpił błąd!',
              html: 'Wysyłanie wiadomości nie powiodło się.',
              type: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.cancelAction();
            });
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: 'Wystąpił błąd!',
            html: 'Wysyłanie wiadomości nie powiodło się.',
            type: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          }).then(() => {
            config.cancelAction();
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }

  static removeItem (instance, config) {
    Vue.swal({
      title: config.confirmTitle,
      text: config.confirmText,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: config.confirmButtonText ? config.confirmButtonText : 'Tak, usuń',
      cancelButtonText: 'Anuluj'
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpointBase + config.id).then(response => {
          if (response.data.success) {
            Vue.swal({
              title: config.successTitle,
              html: config.successText,
              type: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            Vue.swal({
              title: config.errorTitle,
              html: config.errorText,
              type: 'warning',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.cancelAction();
            });
          }
        }).catch(error => {
          console.log(error);
          Vue.swal({
            title: config.errorTitle,
            html: config.errorText,
            type: 'warning',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }
}
